import { FCM_STARFISH_PSF_TO_SAP_LOCAL_FLOW } from 'src/app/shared/fcm/configs';
import { createExperimentFcmConfig } from 'src/app/shared/hooks/experiment';

export const FCM_EXPERIMENT_PSF_TO_SAP_LOCAL_FLOW = createExperimentFcmConfig({
	experimentName: FCM_STARFISH_PSF_TO_SAP_LOCAL_FLOW.name,
	fcmConfigs: {
		config: FCM_STARFISH_PSF_TO_SAP_LOCAL_FLOW,
	},
	isEnabled: ({ fcm }) => fcm.config.isEnabled,
});
